import ApiService from '../../common/services/api'
import LastConfigStorage from '../../common/last_config.storage'

const state = {
  kioskHttpStatus: undefined,
  kiosk: undefined
}

const getters = {
  getKiosk: (state) => state.kiosk,
  getKioskHttpStatus: (state) => state.kioskHttpStatus
}

const actions = {
  fetchKiosk ({ commit }, {placeContextId, kioskToken}) {
      ApiService
        .get(`/1/kiosks/${placeContextId}/${kioskToken}.json`)
        .then(response => {
          commit('SET_KIOSK', response.data || undefined)
          commit('SET_KIOSK_HTTP_STATUS', response.status)

          LastConfigStorage.saveLastConfig(response.data)
        })
        .catch(error => {
          const lastConfig = LastConfigStorage.getLastConfig()
          if (lastConfig) {
            commit('SET_KIOSK', LastConfigStorage.getLastConfig())
            commit('SET_KIOSK_HTTP_STATUS', 200)

            return
          }

          commit('SET_KIOSK_HTTP_STATUS', error.response.status)
        })
  },
}

const mutations = {
  SET_KIOSK_HTTP_STATUS: (state, kioskHttpStatus) => (state.kioskHttpStatus = kioskHttpStatus),
  SET_KIOSK: (state, kiosk) => (state.kiosk = kiosk)
}

export default {
  state,
  getters,
  actions,
  mutations
}
